// Added by Sejune Oh on 2019-03-22
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react'
import { WithTheme, withTheme } from '@material-ui/core'
import { InputProps as StandardInputProps } from '@material-ui/core/Input'
import { FilledInputProps } from '@material-ui/core/FilledInput';
import { OutlinedInputProps } from '@material-ui/core/OutlinedInput';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactKeyUpEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime Elements
import { StyledTextField, InputCommonProps, InputBaseFCProps } from '../Input'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface NormalInputFieldBaseFCProps extends InputBaseFCProps, InputCommonProps {
    isErrorOccured?: boolean
    onInputKeyUp?: ReactKeyUpEvent
    min?: number
    max?: number
    step?: string
    readOnly?: boolean
    curValue?: any
}

interface NormalInputFieldFCProps extends NormalInputFieldBaseFCProps, WithTheme {
    onBlur?: StandardInputProps['onBlur'] | FilledInputProps['onBlur'] | OutlinedInputProps['onBlur'];
    onChange?: StandardInputProps['onChange'] | FilledInputProps['onChange'] | OutlinedInputProps['onChange'];
    onFocus?: StandardInputProps['onFocus'] | FilledInputProps['onFocus'] | OutlinedInputProps['onFocus'];
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const NormalInputField = (props: NormalInputFieldFCProps) => {
    const { isErrorOccured, onChange, onBlur, onInputKeyUp, readOnly, inputProps, InputProps, ...other } = props
    return (
        <StyledTextField
            {...other}
            aria-describedby="intput"
            data-error={isErrorOccured}
            autoComplete="off"
            InputProps={{
                error: isErrorOccured,
                onChange,
                onBlur,
                onKeyUp: onInputKeyUp,
                readOnly,
                ...InputProps
            }}
            inputProps={{
                'data-error': isErrorOccured,
                ...inputProps
            }}
            InputLabelProps={{
                shrink: true,
            }}
        />
    )
}

export default withTheme(NormalInputField)
